@if (totalPrice > 0) {
  <h3 i18n>Produits sélectionnés</h3>
  <div class="layout--row layout--gap">
    <div class="layout--two-thirds-width layout__inner-card product-card">
      <p-divider class="product-card__title"><strong i18n>Sommaire</strong></p-divider>
      <div class="layout--column">
        @for (product of selectedProducts; track product) {
          <div class="product-card__product">
            @if (product.duration && isWholeLife(product.duration)) {
              <p i18n
                >Assurance permanente ({{ product.duration }} -
                {{ product.coverage | currency: 'CAD' : 'symbol-narrow' : '1.0-0' }})
              </p>
            }
            @if (product.duration && !isWholeLife(product.duration)) {
              <p i18n
                >Assurance temporaire ({{ product.duration }} -
                {{ product.coverage | currency: 'CAD' : 'symbol-narrow' : '1.0-0' }})
              </p>
            }
            @if (product.riderType === riderType.CHILD) {
              <p i18n
                >Ajout - Avenant pour enfant ({{
                  product.coverage | currency: 'CAD' : 'symbol-narrow' : '1.0-0'
                }})
              </p>
            }
            @if (product.riderType === riderType.CANCER) {
              <p i18n
                >Ajout - Assurance cancer ({{
                  product.coverage | currency: 'CAD' : 'symbol-narrow' : '1.0-0'
                }})
              </p>
            }
            @if (product.riderType === riderType.DISABILITY) {
              <p i18n
                >Ajout - Assurance invalidité ({{ product.riderDuration }} ans -
                {{ product.coverage | currency: 'CAD' : 'symbol-narrow' : '1.0-0' }})
              </p>
            }
            <p>{{ product.price | currency }}</p>
          </div>
        }
      </div>
    </div>
    <div class="layout--third-width layout__inner-card price-card">
      <p-divider class="price-card__title"><strong i18n>Prime mensuelle total</strong></p-divider>
      <div class="layout--row">
        <span class="price-card__price"
          ><strong>{{ totalPrice | currency }}</strong></span
        >
        <span class="price-card__price--unit" i18n>/mois</span>
      </div>
    </div>
  </div>
}
